module.exports = __webpack_public_path__ + "img/SSW_LOGO.19aca0eb.png";